import React from 'react';
import CustomDatePicker from './../CustomDatePicker/CustomDatePicker';

export const KeyTypeEnum = {
	1: 'ONEDAY',
	2: 'FOUREIGHTWEEKS',
};

export default function DateTime({ keyType, selectedDateInput, onDateChange }) {
	const today = new Date();
	const [selectedDate, setSelectedDate] = React.useState();

	// Sync von außen kommende Änderungen
	React.useEffect(() => {
		if (selectedDateInput) {
			setSelectedDate(new Date(selectedDateInput));
		}
	}, [selectedDateInput]);

	// Automatische Vorauswahl für FOUREIGHTWEEKS (nur einmal, wenn noch nichts gesetzt)
	React.useEffect(() => {
		if (keyType === KeyTypeEnum[2] && !selectedDateInput && !selectedDate) {
			const preselected = today; // ggf. anpassen (z.B. add days)
			setSelectedDate(preselected);
			onDateChange && onDateChange(preselected);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [keyType]);

	const handleSetDate = (value) => {
		setSelectedDate(value);
		if (onDateChange) {
			onDateChange(value);
		}
	};

	return (
		<>
			{keyType === KeyTypeEnum[1] ? (
				<>
					<CustomDatePicker
						isInvalid={false}
						disableInput={false}
						value={selectedDate}
						minDate={new Date(today.getTime() - 1 * 24 * 60 * 60 * 1000)}
						maxDate={new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000)}
						setSelectedDate={handleSetDate}
					/>
				</>
			) : keyType === KeyTypeEnum[2] ? (
				<>
					<CustomDatePicker
						isInvalid={false}
						disableInput={true}
						value={new Date(today.getTime() + 0 * 24 * 60 * 60 * 1000)}
						maxDate={new Date(today.getTime() + 0 * 24 * 60 * 60 * 1000)}
						minDate={new Date(
							today.getTime() + 0 * 24 * 60 * 60 * 1000
						).toISOString()}
						setSelectedDate={handleSetDate}
					></CustomDatePicker>
				</>
			) : (
				new Error('DateTime component must include a keyType property')
			)}
		</>
	);
}
